<cm-select
    *ngIf="profile.role_id === ROLE_CODES.PROFESSIONAL && locationsFeatureFlag"
    class="inner-component managers"
    [class.error]="showError && form.get('managerProfileId').errors"
    [class.active-placeholder]="managerPlaceholder"
    [placeholder]="managerPlaceholder || 'Please select'"
    [options]="managers"
    [formControl]="form.get('managerProfileId')"
    [defaultSearch]="true"
    [defaultValue]="form.get('managerProfileId')?.value"
    (changeSearchValue)="setManagersWithSearch($event)"
></cm-select>
<cm-select
    *ngIf="profile.role_id === ROLE_CODES.ORGANIZATION_ADMIN || !locationsFeatureFlag"
    class="inner-component managers"
    [class.error]="showError && form.get('managerProfileId').errors"
    [class.active-placeholder]="managerPlaceholder"
    [placeholder]="managerPlaceholder || 'Please select'"
    [options]="managers"
    [formControl]="form.get('managerProfileId')"
    [defaultSearch]="true"
    [defaultValue]="form.get('managerProfileId')?.value"
    (changeSearchValue)="setManagersWithSearch($event)"
></cm-select>
